<template>
  <div class="speed-controller">
    <div class="button-wrapper">
      <font-awesome-icon icon="backward" class="button" @click="speedDown" v-if="!isMinSpeed" />
    </div>
    <span class="current-speed">{{speedRate}}x</span>
    <div class="button-wrapper">
      <font-awesome-icon icon="forward" class="button" @click="speedUp" v-if="!isMaxSpeed" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpeedController',
  data() {
    return {
      speed: 100,
    };
  },
  computed: {
    speedRate() {
      return this.$store.getters.speedPercentage / 100;
    },
    isMinSpeed() {
      return this.$store.getters.isMinSpeed;
    },
    isMaxSpeed() {
      return this.$store.getters.isMaxSpeed;
    },
  },
  methods: {
    speedDown() {
      this.$store.dispatch('speedDown');
    },
    speedUp() {
      this.$store.dispatch('speedUp');
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes bounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.speed-controller {
  z-index: 200;
  display: flex;
  align-items: center;
  text-align: left;

  .current-speed {
    display: inline-block;
    width: 5rem;
    text-align: center;
    font-size: 1.8rem;
    font-weight: bolder;
    color: #aaa;
    margin: 0 0.5em;
  }

  .button-wrapper {
    width: 1.8rem;
    .button {
      display: inline-block;
      width: 1.8rem;
      height: 1.8rem;
      color: #aaa;
      cursor: pointer;

      &:hover,
      &:focus {
        animation: bounce 0.5s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/SpeedController.vue